import $ from "jquery"

$(function () {

	/**
	 * @param target
	 * @returns {{total: number, hours: number, seconds: number, minutes: number, days: number}}
	 */
	const getTimeRemaining = function (target) {
		const total = Date.parse(target) - Date.parse(new Date());
		const seconds = Math.floor((total / 1000) % 60);
		const minutes = Math.floor((total / 1000 / 60) % 60);
		const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
		const days = Math.floor(total / (1000 * 60 * 60 * 24));

		return {
			total,
			days,
			hours,
			minutes,
			seconds,
		};
	}

	$('.countdown').each(function () {

		const $cd = $(this);
		const target = $cd.data('target');

		setInterval(function() {
			const timeDetails = getTimeRemaining(target);

			$cd.find('span.days').html(timeDetails.days.toString().split('').map(x => '<span>' + x + '</span>').join(''));
			$cd.find('span.hours').html(timeDetails.hours.toString().split('').map(x => '<span>' + x + '</span>').join(''));
			$cd.find('span.minutes').html(timeDetails.minutes.toString().split('').map(x => '<span>' + x + '</span>').join(''));
			$cd.find('span.seconds').html(timeDetails.seconds.toString().split('').map(x => '<span>' + x + '</span>').join(''));
		}, 1000);
	});

});
